import React from "react";

const items = [
  "Licensed & Insured",
  "Owner Operated",
  "Free On-Site Quotes",
  "Heavy Equipment",
  "Abilene, TX",
  "Locally Owned",
  "Residential & Commercial",
  "Rain or Shine",
];

export default function Marquee() {
  const loop = [...items, ...items];
  return (
    <div
      data-testid="marquee-strip"
      className="bg-[#E5231A] border-y border-[#111110] overflow-hidden"
    >
      <div className="marquee-track flex whitespace-nowrap py-4">
        {loop.map((t, i) => (
          <span
            key={i}
            className="font-display font-black uppercase tracking-tighter text-[#111110] text-2xl md:text-3xl px-8 flex items-center gap-8"
          >
            {t}
            <span className="text-[#F4F4EB]">✱</span>
          </span>
        ))}
      </div>
    </div>
  );
}
